import type { QrResponseDto } from "@/api";
import { create } from "zustand";
import { persist } from "zustand/middleware";

type PaymentStore = {
    paymentPayload?: {
        token: string;
        transactionId: string;
        childFrameId: string;
    };
    qr?: QrResponseDto;
    isGeneratingQr: boolean;
    setPaymentPayload: (paymentPayload: PaymentStore["paymentPayload"]) => void;
    setQr: (qr: QrResponseDto) => void;
    setIsGeneratingQr: (isGenerating: boolean) => void;
    resetQr: () => void;
    resetPaymentPayload: () => void;
}

const usePaymentStore = create<PaymentStore>()(
    persist(
        (set) => ({
            paymentPayload: undefined,
            qr: undefined,
            isGeneratingQr: false,
            setPaymentPayload: (paymentPayload: PaymentStore["paymentPayload"]) => set({ paymentPayload }),
            setQr: (qr: QrResponseDto) => set({ qr, isGeneratingQr: false }),
            setIsGeneratingQr: (isGenerating: boolean) => set({ isGeneratingQr: isGenerating }),
            resetQr: () => set({ qr: undefined }),
            resetPaymentPayload: () => set({ paymentPayload: undefined }),
        }),
        { name: "payment-store" }
    )
);

export { usePaymentStore };